import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DashboardLandingPreferenceResponse } from 'src/app/core-module/models/Dashboards/dashboard.models';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { DashboardService } from 'src/app/core-module/services/dashboard.service';
import { ToastrService } from 'src/app/core-module/services/toastr.service';

@Component({
  selector: 'app-landing-page-preference',
  templateUrl: './landing-page-preference.component.html',
  standalone: false
})
export class LandingPagePreferenceComponent implements OnInit, OnChanges {
  @Input() userId?: number;
  @Input() disabled = false;

  preference?: DashboardLandingPreferenceResponse;
  selectedLandingPageId: number | null = null;
  savedLandingPageId: number | null = null;
  loading = false;
  saving = false;
  loadFailed = false;
  private requestNumber = 0;

  constructor(private dashboards: DashboardService, private toastr: ToastrService) {}

  ngOnInit(): void {
    this.loadPreference();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userId'] && !changes['userId'].firstChange) this.loadPreference();
  }

  get customerDefaultName(): string {
    return this.preference?.CustomerDefaultLandingPageID === 2 ? 'Dashboards' : 'Home';
  }

  get savedOptionUnavailable(): boolean {
    return this.savedLandingPageId != null &&
      !this.preference?.LandingPages?.some(option => option.LandingPageID === this.savedLandingPageId);
  }

  save(): void {
    if (this.loading || this.saving || this.disabled ||
        this.selectedLandingPageId === this.savedLandingPageId) return;

    this.saving = true;
    this.dashboards.saveLandingPreference(this.selectedLandingPageId, this.userId).subscribe({
      next: result => {
        this.saving = false;
        if (result.IsError) {
          this.toastr.addToastr(new Toastr({ Type: 3, Message: result.ErrorMessage || 'Unable to save the landing page.' }));
          return;
        }
        this.savedLandingPageId = this.selectedLandingPageId;
        this.toastr.addToastr(new Toastr({ Type: 1, Message: 'Landing page preference saved.' }));
      },
      error: () => {
        this.saving = false;
        this.toastr.addToastr(new Toastr({ Type: 3, Message: 'Unable to save the landing page. Please try again.' }));
      }
    });
  }

  private loadPreference(): void {
    const requestNumber = ++this.requestNumber;
    this.loading = true;
    this.loadFailed = false;
    this.preference = undefined;
    this.dashboards.getLandingPreference(this.userId).subscribe({
      next: result => {
        if (requestNumber !== this.requestNumber) return;
        this.loading = false;
        if (result.IsError) {
          this.loadFailed = true;
          return;
        }
        this.preference = result;
        this.selectedLandingPageId = result.UserLandingPageID;
        this.savedLandingPageId = result.UserLandingPageID;
      },
      error: () => {
        if (requestNumber !== this.requestNumber) return;
        this.loading = false;
        this.loadFailed = true;
      }
    });
  }
}
